import { CheckboxRow } from "@/shared/ui/checkbox";
import type { ProjectUi } from "@/core/projects-ui";

/** A `book` projekt csatlakozási kérdése (kemény kapu: a melléklet a könyv olvasóinak szól). */
export const bookUi: ProjectUi = {
  slug: "book",
  appPath: "/app/book",
  joinTitle: "Csatlakozás a melléklethez",
  joinLead: "A digitális melléklet a könyv olvasóinak szól.",
  registerLead:
    "A digitális melléklet használatához egy egyszerű, ingyenes regisztráció kell, hogy a rendszer követni tudja a kipróbált gyakorlataidat, a kedvenceidet és a jegyzeteidet. Az e-mail-címedet más felhasználók nem látják; a belépőkódot küldjük rá, és ha lent megengeded, a későbbi új funkciókról is értesítünk.",
  isValid: (answers) => answers.reader_declared === true,
  gate: {
    question: "A könyv olvasója vagy?",
    yes: "Igen",
    no: "Nem",
    answers: { reader_declared: true },
    deniedTitle: "A digitális melléklet a könyv olvasóinak szól.",
    deniedLead:
      "Visszaviszünk a könyv oldalára — ott megnézheted a tartalomjegyzékét, és ha tetszik, meg is rendelheted.",
    deniedCta: "Vissza a könyv oldalára",
    deniedHref: "/konyv",
  },
  Fields: ({ answers, onChange }) => (
    <CheckboxRow
      id="reader"
      checked={answers.reader_declared === true}
      onCheckedChange={(v) => onChange({ ...answers, reader_declared: v })}
      required
    >
      A könyv olvasója vagyok.
    </CheckboxRow>
  ),
};
